module.exports = __webpack_public_path__ + "img/104.71ea4151.jpg";